__turbopack_context__.v({
  "app-picker-heading": "AppPicker-module-scss-module__FKUkda__app-picker-heading",
  "menu-item-wrapper": "AppPicker-module-scss-module__FKUkda__menu-item-wrapper",
  "menu-link": "AppPicker-module-scss-module__FKUkda__menu-link",
  "mozilla-link": "AppPicker-module-scss-module__FKUkda__mozilla-link",
  "popup": "AppPicker-module-scss-module__FKUkda__popup",
  "premium": "AppPicker-module-scss-module__FKUkda__premium",
  "trigger": "AppPicker-module-scss-module__FKUkda__trigger",
  "wrapper": "AppPicker-module-scss-module__FKUkda__wrapper",
});
